
// Function to get a cookie by name
function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split("=");
      if (cookieName === name) return cookieValue;
  }
  return null;
}

// Function to set a cookie with expiration time (in hours)
function setCookie(name, value, hours) {
  const date = new Date();
  date.setTime(date.getTime() + hours * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/; SameSite=Lax`;
}




document.addEventListener('DOMContentLoaded', () => {
  // Mega Menu (Dropdown Menu)
  const megaMenu = () => {
    const navBg = document.getElementById('site-mnu');
    const navItems = document.querySelectorAll('.nav--dropdown');
    let hoverTimeout;
    let activeSubmenu = null; // Track the currently active submenu
  
    navItems.forEach((navItem) => {
      const submenu = navItem.querySelector('.sub-mnu-container');
  
      navItem.addEventListener('mouseover', () => {
        // Hide the previously active submenu if it exists and is not the current one
        if (activeSubmenu && activeSubmenu !== submenu) {
          activeSubmenu.classList.remove('active-sub');
          navItem.classList.remove('active-nav-item'); // Remove highlight from previous navItem
        }
        
        submenu.classList.add('active-sub');
        navItem.classList.add('active-nav-item'); // Highlight the current navItem
        // navBg?.classList.add('changeNavBg');
        clearTimeout(hoverTimeout); // Clear timeout to avoid premature hiding
  
        // Update the active submenu
        activeSubmenu = submenu;
      });
  
      navItem.addEventListener('mouseout', () => {
        navItem.classList.remove('active-nav-item');
        hoverTimeout = setTimeout(() => {
          submenu.classList.remove('active-sub');
          //navBg?.classList.remove('changeNavBg');
          
          // Reset the active submenu if this is the currently active one
          if (activeSubmenu === submenu) {
            activeSubmenu = null;
          }
        }, 300); // Delay to make it smoother
      });
    });
  };

  // Hamburger Menu
  const openNav = () => {
    const ham = document.getElementById('mnu-icon'); // Hamburger icon
    const navList = document.querySelector('.shop-nav'); // Main nav list
    const siteLinks = document.querySelectorAll('.nav--link'); // All nav links
    const navigation = document.getElementById('site-mnu'); // Navigation menu container
    const body = document.body; // Get the body element for scrolling control
    let isOpen = false; // Track if the menu is open
  
    ham.addEventListener('click', (event) => {
      event.stopPropagation(); // Prevent click from propagating to document
  
      if (!isOpen) {
        navList.style.display = 'flex'; // Make the nav visible
        setTimeout(() => {
          navList.classList.add('atv-s-mnu'); // Start the animation
        }, 10); // Small delay for smoother animation
  
        // Animate the links with a delay
        siteLinks.forEach((link, index) => {
          setTimeout(() => {
            link.classList.add('atv-n-l');
          }, index * 100); // Adjust delay for each link
        });
        body.style.overflow = 'hidden'; // Prevent body from scrolling
      } else {
        navList.classList.remove('atv-s-mnu'); // Start the fade-out animation
        siteLinks.forEach((link) => {
          link.classList.remove('atv-n-l'); // Fade out the links
        });
  
        setTimeout(() => {
          navList.style.display = 'none'; // Hide the menu after the fade-out
          body.style.overflow = 'auto'; // Re-enable scrolling
        }, 300); // Delay should match the transition duration (0.3s)
      }
  
      ham.classList.toggle('ham-x');
      isOpen = !isOpen;
    });
  
    // Close menu if clicking outside the menu
    document.addEventListener('click', (event) => {
      const isClickInsideMenu = navList.contains(event.target) || ham.contains(event.target);
  
      if (!isClickInsideMenu && isOpen) {
        navList.classList.remove('atv-s-mnu'); // Start fade-out animation
        siteLinks.forEach((link) => {
          link.classList.remove('atv-n-l'); // Fade out links
        });
  
        setTimeout(() => {
          navList.style.display = 'none'; // Hide the menu after the fade-out
          body.style.overflow = 'auto'; // Re-enable scrolling
        }, 300); // Match the delay with the CSS transition duration
        ham.classList.remove('ham-x');
        isOpen = false; // Update the isOpen state
      }
    });
  };

  // Change Navigation on Scroll
  const changeNavOnScroll = () => {
    const navBg = document.querySelector('.header');
    const hero = document.querySelector('.sectionOne');

    window.addEventListener('scroll', () => {
      const heroHeight = hero.offsetHeight;
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;
      const threshold = heroHeight * 0.1; // 10% of hero section height

      if (scrollPosition > threshold) {
        navBg.classList.add('changeNavBg');
      } else {
        navBg.classList.remove('changeNavBg');
      }
    });
  };

  // Top Padding Adjustment
  const adjustTopPadding = () => {
    const sourceElement = document.querySelector('.header');
    const targetElements = document.querySelectorAll('.top-hero'); // Select all elements with the 'top-hero' class
  
    // Check if the header has the 'fixed-header' class (or is fixed via other logic)
    if (sourceElement.classList.contains('fixed-header')) {
      const sourceHeight = sourceElement.offsetHeight;
      const totalPadding = sourceHeight; // Add extra padding if needed
      
      // Loop through each .top-hero element and apply the padding
      targetElements.forEach(targetElement => {
        targetElement.style.paddingTop = totalPadding + 'px';
      });
    } else {
      // If header is not fixed, remove the padding
      targetElements.forEach(targetElement => {
        targetElement.style.paddingTop = ''; // Reset padding to default
      });
    }
  };
  

  const adjustMobileNavHeight = () => {
    const headerEl = document.querySelector('.header');
    const topBarEl = document.querySelector('.top-bar');
    const menuElement = document.querySelector('.shop-nav');
  
    // Check if the viewport is mobile (max-width: 768px or any threshold you'd like)
    if (window.matchMedia('(max-width: 964px)').matches) {
      if (headerEl && menuElement) {
        const headerHeight = headerEl.offsetHeight;
        const viewportHeight = window.innerHeight;
        let topBarHeight = 0;
  
        // Check if top-bar exists and calculate its height if visible
        if (topBarEl) {
          const topBarRect = topBarEl.getBoundingClientRect();
  
          // If the top bar is still partially visible in the viewport, subtract its height
          if (topBarRect.bottom > 0 && topBarRect.top < viewportHeight) {
            topBarHeight = topBarEl.offsetHeight;
          }
        }
  
        // Check if the header has the class 'fixed-header'
        if (headerEl.classList.contains('fixed-header')) {
            additionalOffset = 0; // Subtract 10px for fixed-header
            menuElement.style.height = `${viewportHeight - headerHeight - topBarHeight - additionalOffset - 0}px`;

        } else {
          menuElement.style.height = `${viewportHeight - headerHeight - topBarHeight - 0}px`;

        }
      }
    }else{
      menuElement.style.height = `auto`;
    }
  };
  
  const topBar = document.querySelector('.top-bar');
  const header = document.querySelector('.header');

  // If the top-bar doesn't exist, immediately fix the header
  if (!topBar) {
    header.classList.add('fixed-header');
  } else {
    // Otherwise, handle scroll-based logic
    document.addEventListener('scroll', function() {
      // Get the bottom position of the top-bar relative to the viewport
      const topBarBottom = topBar.getBoundingClientRect().bottom;

      if (topBarBottom <= 0) {
        // If top-bar is out of view, fix the header at the top
        header.classList.add('fixed-header');
      } else {
        // If top-bar is in view, remove fixed position from the header
        header.classList.remove('fixed-header');
      }
    });
  }

  document.querySelectorAll('.nav-link-wrap').forEach(navLinkWrap => {
    // Check if this element has a child with the class 'sub-mnu-grandchild'
    const subMenuGrandchild = navLinkWrap.querySelector('.sub-mnu-grandchild');
    const subMnuTopContent = navLinkWrap.querySelector('.sub-mnu-top-content');
  
    if (subMenuGrandchild && subMnuTopContent) {
      // Create the mobile__nav__icn__drop_lvl_2 structure dynamically
      const dropdownIcon = document.createElement('span');
      dropdownIcon.classList.add('mobile__nav__icn__drop_lvl_2');
  
      const hrDiv = document.createElement('div');
      hrDiv.classList.add('hr');
      
      const vtDiv = document.createElement('div');
      vtDiv.classList.add('vt');
  
      // Append the hr and vt divs into the dropdownIcon span
      dropdownIcon.appendChild(hrDiv);
      dropdownIcon.appendChild(vtDiv);
  
      // Insert the dropdownIcon after the <a> tag inside .sub-mnu-top-content
      const link = subMnuTopContent.querySelector('a');
      if (link) {
        subMnuTopContent.insertBefore(dropdownIcon, link.nextSibling);
      }
    }
  });

  // Dynamically set grid-template-columns for .sub-mnu-nav-col3
  const submenuCols = document.querySelectorAll('.sub-mnu-nav-col3 .sub-mnu-col');

  submenuCols.forEach(submenuCol => {
    const listItems = submenuCol.querySelectorAll('.sub-menu-grid').length;
    if (listItems > 0) {
      submenuCol.style.gridTemplateColumns = `repeat(${listItems}, 1fr)`;  // Dynamically set the columns
    }
  });

  // Handle mobile nav links
  const mobileNavLinks = document.querySelectorAll('.mobile-nav-link');
  let activeMenu = null;

  mobileNavLinks.forEach(link => {
    const handleClick = function(event) {
      event.preventDefault();
      const submenu = this.nextElementSibling;

      // Close any other active submenu
      if (activeMenu && activeMenu !== submenu) {
        activeMenu.classList.remove('active');
        activeMenu.previousElementSibling.classList.remove('active');
      }

      // Toggle the current submenu
      submenu.classList.toggle('active');
      this.classList.toggle('active');

      activeMenu = submenu.classList.contains('active') ? submenu : null;
    };

    link.addEventListener('click', handleClick);
    link.addEventListener('touchstart', handleClick); // Support for touch devices
  });

  // Handle submenu for grandchild links
  const dropIcons = document.querySelectorAll('.mobile__nav__icn__drop_lvl_2');
  let activeGrandMenu = null;
  let activeVT = null;

  dropIcons.forEach(icon => {
      icon.addEventListener('click', function() {
          const grandSubmenu = this.closest('.nav-link-wrap')?.querySelector('.sub-mnu-grandchild');
          const vtElement = this.querySelector('.vt');

          if (!grandSubmenu || !vtElement) {
              return;
          }

          // Close any other active grandchild menu
          if (activeGrandMenu && activeGrandMenu !== grandSubmenu) {
              activeGrandMenu.classList.remove('show');
              if (activeVT) activeVT.classList.remove('active');
          }

          grandSubmenu.classList.toggle('show');
          vtElement.classList.toggle('active');

          // Update active grandchild trackers
          activeGrandMenu = grandSubmenu.classList.contains('show') ? grandSubmenu : null;
          activeVT = vtElement.classList.contains('active') ? vtElement : null;
      });
  });

  const hoverCards = document.querySelectorAll('.magic-bg, .magic-bg-mask');
  hoverCards.forEach(card => {
      card.onmousemove = function (e) {
          const { left, top } = card.getBoundingClientRect(); // Get element position
          const x = e.clientX - left; // Calculate x relative to the card
          const y = e.clientY - top;  // Calculate y relative to the card
  
          // Set CSS variables for cursor coordinates
          card.style.setProperty("--x", `${x}px`);
          card.style.setProperty("--y", `${y}px`);
      };
  });
  



// Iterate over each button and apply animations


  megaMenu();
  openNav();
  changeNavOnScroll();
  adjustTopPadding();
  adjustMobileNavHeight();

  document.addEventListener('scroll', adjustTopPadding);
  window.addEventListener('scroll', adjustMobileNavHeight);


  function debounce(func, wait = 100) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  window.addEventListener('resize', adjustMobileNavHeight);

  window.addEventListener('resize', debounce(() => {
    adjustTopPadding();
}));









  const floatingInputs = document.querySelectorAll('.floating-label input');

floatingInputs.forEach((input) => {
    const label = input.nextElementSibling;

    // Check if the input/textarea has content on page load
    if (input.value.trim() !== '') {
        label.classList.add('active');
        input.classList.add('active'); // Add active class to input/textarea
    }

    // Handle input events
    input.addEventListener('input', () => {
        if (input.value.trim() !== '') {
            label.classList.add('active');
            input.classList.add('active'); // Add active class to input/textarea
        } else {
            label.classList.remove('active');
            input.classList.remove('active'); // Remove active class from input/textarea
        }
    });

    // Handle focus events
    input.addEventListener('focus', () => {
        label.classList.add('active');
        input.classList.add('active'); // Add active class to input/textarea
    });

    // Handle blur events
    input.addEventListener('blur', () => {
        if (input.value.trim() === '') {
            label.classList.remove('active');
            input.classList.remove('active'); // Remove active class from input/textarea
        }
    });
});



function autoResize() {
  this.style.height = 'auto';
  this.style.height = this.scrollHeight + 'px';
}




    // Close popup but reopen on reload
    document.querySelector(".close-sn-pu")?.addEventListener("click", closePopupTemporary);

    // Close popup and prevent showing for 48 hours
    document.querySelector(".close-sn-pu-done")?.addEventListener("click", closePopupFor48Hours);


});



